<template>
  <div
    :class="[ns.b()]"
    :style="styles"
    data-test-name="spacer"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { isNumber } from 'lodash-unified'
import { useNamespace } from '@bigin/hooks'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'BSpacer',
})

const props = defineProps({
  width: {
    type: [Number, String],
    default: 0,
  },
  height: {
    type: [Number, String],
    default: 0,
  },
})

const ns = useNamespace('spacer')

const styles = computed(() => {
  let styles: Record<string, any> = {}

  if (props.width) {
    styles = {
      ...styles,
      width: isNumber(props.width) ? `${props.width}px` : props.width,
    }
  }

  if (props.height) {
    styles = {
      ...styles,
      height: isNumber(props.height) ? `${props.height}px` : props.height,
    }
  }

  return styles as CSSProperties
})
</script>
